import * as basicInfo from './basic-info';
import * as contact from './contact';
import * as social from './social';
import * as orderLink from './order-link';
import * as customLink from './custom-link';
import * as openingHours from './opening-hours';
import * as imageGallery from './image-gallery';

export const Basic = {
    ...basicInfo,
    ...contact,
    ...social,
    ...orderLink,
    ...customLink,
    ...openingHours,
    ...imageGallery,
};
